export const RecommendationPageTitle = {
    name: "Recommendations",
    translationKey: "recommendations",
};

export const RecommendationPageSubtitle = {
    name: "Here are some popular recommendations selected for you based on your decision making stage",
    translationKey: "recommendationPageSubtitle",
};

export const RecommendationBannerText = {
    name: "Recommended for you",
    translationKey: "recommendationBannerText",
};

export const RecommendationBannerTextShort = {
    name: "For you",
    translationKey: "recommendationBannerTextShort",
};

export const RecommendationButtonText = {
    name: "Check it out",
    translationKey: "recommendationCTA",
};

export const ViewMoreText = {
    name: "View more",
    translationKey: "viewMoreText",
};
